// extracted by mini-css-extract-plugin
module.exports = {"LeverandoerTjenesteSide":"LeverandoerTjenesteSide_LeverandoerTjenesteSide__hzhO8","Wrapper":"LeverandoerTjenesteSide_Wrapper__1KahV"};